export default function useUser() {
  const usuarioLogado = localStorage.getItem("@DNACenter:codigoUsuario");
  return usuarioLogado;
}
